var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, hideWhenCreatingAndEditing } from 'src/types/columnFlags';
import ColumnThatIsChildTableConstructor from 'src/utils/ColumnThatIsChildTableConstructor';
import getRecords from 'src/utils/entityOperations/getRecords';
import createRecords from 'src/utils/entityOperations/createRecords';
import getRecordById from 'src/utils/entityOperations/getRecordById';
import updateRecords from 'src/utils/entityOperations/updateRecords';
import repeatLastFetch from 'src/utils/entityOperations/repeatLastFetch';
const controlledActions = {
    create: [148],
    fetch: [143],
    update: [151],
    delete: [154],
    downloadList: [-1],
    uploadList: [-1]
};
const columns = () => {
    const ruleType = (id) => getRecordById('ci.rule_types', id);
    const handleCopyWithConditions = (cellProps, ctx, e) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const rule = cellProps.row;
        const conditions = getRecords('ci.rule_conditions')
            .filter((rc) => (rc.rule_id === rule.id));
        const newRuleId = (_c = (_b = (_a = (yield createRecords('ci.rules', [rule]))) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.id;
        if (newRuleId && conditions.length > 0) {
            const copiedConditions = [];
            for (const condition of conditions) {
                copiedConditions.push(Object.assign(Object.assign({}, condition), { rule_id: newRuleId }));
            }
            createRecords('ci.rule_conditions', copiedConditions);
        }
    });
    const menuItems = [
        { name: 'copy_with_conditions', label: 'Copy with conditions', icon: 'mdi-content-duplicate', clickHandler: handleCopyWithConditions }
    ];
    const applicationOrderFormatter = (cellProps) => {
        const applicationOrder = cellProps.row.application_order;
        const res = applicationOrder ? applicationOrder.toFixed(3) : '';
        return res;
    };
    const res = [
        { name: 'row_menu', type: 'row_menu', rowMenuItems: menuItems, menuItemShortcuts: ['copy', 'delete'], hideWhenCreatingAndEditing },
        { name: 'id', label: 'ID', style: 'width:50px', field: 'id', align: 'left', hideWhenCreatingAndEditing, hideWhenDisplaying, isInteger },
        { name: 'application_order', inlineEdit: true, style: 'font-family:monospace', displayValueGetter: applicationOrderFormatter, label: 'Order', field: 'application_order', align: 'left', hideWhenCreating: true, hideWhenDisplaying: true, doNotIncludeIntoCopiedRecord: true },
        { name: 'rule_type_id', style: 'white-space: nowrap; max-width:400px; overflow: hidden; text-overflow: ellipsis', label: 'Rule type', field: 'rule_type_id', align: 'left', required: true, references: 'ci.rule_types' },
        { name: 'rule_type_group_id', hideWhenDisplaying, hideWhenCreatingAndEditing },
        { name: 'value', popupEditWidth: '70px', showZeroInPlaceOfNull: true, cellIsPercent: (cellProps) => { var _a; return Boolean((_a = ruleType(Number(cellProps.row.rule_type_id))) === null || _a === void 0 ? void 0 : _a.is_percent); }, label: 'Value', editable: true, field: 'value', inlineEdit: (props) => !((ruleType(Number(props.row.rule_type_id)) || {}).options), cellReferences: (props) => (ruleType(Number(props.row.rule_type_id)) || {}).options, required: true }
    ];
    res.push(
    // @ts-ignore // TODO: fix: type of tableProps on Column type is not implemented correctly for the case of ColumnThatIsChildTableConstructor
    ColumnThatIsChildTableConstructor({
        label: 'Rule condition(s)',
        name: 'rule_conditions',
        // @ts-ignore
        field: '',
        style: 'width: 400px;',
        thStyles: 'padding-left:40px;'
    }, {
        localEntityNameProp: 'ci.rule_conditions',
        filtersProp: cellProps => ({ rule_id: cellProps.row.id }),
        initialRowsPerPageProp: 999,
        startingSortingModelProp: [{ application_order: 1, field: 'rule_condition_type_id', direction: 'asc' }]
    }));
    return res;
};
const rowDragCompletionCallback = (draggedRow, targetRow) => __awaiter(void 0, void 0, void 0, function* () {
    if (!draggedRow || !targetRow)
        return;
    const applicationOrderNow = draggedRow.application_order || 0;
    const applicationOrderTarget = targetRow.application_order || 0;
    const applicationOrderNew = applicationOrderTarget + ((applicationOrderNow > applicationOrderTarget) ? -0.001 : 0.001);
    if (draggedRow.id === undefined)
        return;
    yield updateRecords('ci.rules', [{ id: draggedRow.id, application_order: applicationOrderNew }]);
    repeatLastFetch('ci.rules');
});
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    rowDragCompletionCallback,
    remoteEntityName: 'ci.rules',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Rules',
    repeatLastFetchOnContextOrgIdChange: true
});
export default localEntity;
